import type { FileRouteTypes } from "@/routeTree.gen";

type To = FileRouteTypes["to"];
type FullPath = FileRouteTypes["fullPaths"];

export const APP_ROUTES_TO = {
  ROOT: "/",
  STRINGS: "/strings",
  USERS: "/users",
  PERMISSION_GROUPS: "/permission-groups",
  API_KEYS: "/api-keys",
  PROFILE: "/profile",
  SETTINGS: "/settings",
} as const satisfies Record<string, To>;

export const APP_ROUTES_FULL = {
  ROOT: APP_ROUTES_TO.ROOT,
  STRINGS: `${APP_ROUTES_TO.STRINGS}/`,
  USERS: `${APP_ROUTES_TO.USERS}/`,
  PERMISSION_GROUPS: `${APP_ROUTES_TO.PERMISSION_GROUPS}/`,
  API_KEYS: `${APP_ROUTES_TO.API_KEYS}/`,
  PROFILE: `${APP_ROUTES_TO.PROFILE}/`,
  SETTINGS: `${APP_ROUTES_TO.SETTINGS}/`,
} as const satisfies Record<string, FullPath>;
